/**
 * @fileoverview App component.core
 */
'use strict';
// React Import
import React, { Component } from 'react';
import { render } from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import Main from './Main';
// Library Import
import '../../lib/mobiscroll/themes/windows';
import '../../lib/mobiscroll/themes/auto-theme';
import '../../lib/mobiscroll/i18n/ja';
// Util Import
import * as LogUtil from '../../util/LogUtil';

/**
 * グローバルエラーを捕捉
 *
 * @name window.onerror
 * @function
 * @param {String} message メッセージ
 * @param {String} source ソース
 * @param {String} line 行
 * @param {String} column 列
 * @param {Object} error エラーオブジェクト
 */
window.onerror = (message, source, line, column, error) => {
  LogUtil.e(
    'message:' +
      message +
      ' source:' +
      source +
      ' line:' +
      line +
      ' column:' +
      column +
      ' stack:' +
      error.stack
  );
};

/**
 * App
 *
 * @class App
 * @extends {Component}
 */
class App extends Component {
  constructor(props) {
    super(props);
    LogUtil.d('App Class constructor call');
  }

  /**
   * 描画
   *
   * @returns {Object} 画面を構成する要素
   * @memberof App
   */
  render() {
    return (
      <BrowserRouter>
        <Main />
      </BrowserRouter>
    );
  }
}
export default App;



// WEBPACK FOOTER //
// ./src/js/component/core/App.jsx